var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBasic = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 328,
    height: 336,
    fill: "none",
    viewBox: "0 0 328 336",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#basic_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0-39h328v375H0z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#basic_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#basic_svg__c)",
    d: "M115.264 340.207c-95.306 11.057-167.61-46.875-176.377-59.496v151.443h441.717V206.793c-36.359 70.313-170.034 122.356-265.34 133.414"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#basic_svg__d)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#basic_svg__e)",
    d: "M202.311 193.072.028 334.34l169.866-84.049-5.702 44.291L473.533 178.02 450.96 50 197.399 235.814z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "basic_svg__c",
    x1: 159.745,
    x2: 159.745,
    y1: 283.115,
    y2: 354.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B2E30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "basic_svg__e",
    x1: 4.788,
    x2: 343.031,
    y1: 334.914,
    y2: 174.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#464646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.819,
    stopColor: "#131313"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "basic_svg__b",
    width: 585.717,
    height: 369.361,
    x: -133.113,
    y: 134.793,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect1_foregroundBlur_12055_2818",
    stdDeviation: 36
  })), /*#__PURE__*/React.createElement("filter", {
    id: "basic_svg__d",
    width: 573.506,
    height: 384.34,
    x: -49.973,
    y: 4,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12055_2818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12055_2818",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_12055_2818"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "basic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-39h328v375H0z"
  })))));
};
export default SvgBasic;